// App.js
import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LessonDashboard from './LessonDashboard';
import LoginPage from './LoginPage';

function App() {
  // 인증 상태 관리 (예시: 초기 false, 로그인 시 true)
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <Routes>
      {/* 로그인 페이지 */}
      <Route path="/login" element={<LoginPage onLogin={() => setIsAuthenticated(true)} />} />
      {/* 인증되지 않은 사용자는 /dashboard 접근 시 로그인 페이지로 리다이렉트 */}
      <Route path="/dashboard" element={isAuthenticated ? <LessonDashboard /> : <Navigate to="/login" replace />} />
      {/* 기본 경로: 인증 상태에 따라 리다이렉트 */}
      <Route path="*" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />} />
    </Routes>
  );
}

export default App;
